import { render, staticRenderFns } from "./TakipSorgulaView.vue?vue&type=template&id=6e38c25a"
import script from "./TakipSorgulaView.vue?vue&type=script&lang=ts"
export * from "./TakipSorgulaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports